import { render } from "./Flights.vue?vue&type=template&id=65bbaab8&scoped=true"
import script from "./Flights.vue?vue&type=script&lang=js"
export * from "./Flights.vue?vue&type=script&lang=js"

import "./Flights.vue?vue&type=style&index=0&id=65bbaab8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bbaab8"]])

export default __exports__